import {
  applicationShellPageContentClassName,
  applicationShellPageLayoutClassName,
} from "components/ApplicationShell/pageSpacing";

export const computePageApplicationShellLayoutClassName =
  applicationShellPageLayoutClassName;

export const computePageApplicationShellContentClassName =
  applicationShellPageContentClassName;

export function getComputePageLayoutClassName({
  isApplicationShellRedesign,
  legacyClassName,
}: {
  isApplicationShellRedesign: boolean;
  legacyClassName: string;
}) {
  return isApplicationShellRedesign
    ? computePageApplicationShellLayoutClassName
    : legacyClassName;
}

export function getComputePageContentClassName({
  isApplicationShellRedesign,
  legacyClassName,
}: {
  isApplicationShellRedesign: boolean;
  legacyClassName: string;
}) {
  return isApplicationShellRedesign
    ? computePageApplicationShellContentClassName
    : legacyClassName;
}
